import { SchoolEnrollmentDetailsAsl } from './../../component/children/model/school-enrollment-details-asl.model';
import { StudentTerminationStatus } from './../../component/children/model/student-termination-status.model';
import { School } from '../school.model';
import { PERSON } from 'src/app/component/auth/model/user.model';

export class Student {
    ID?: number;
    PERSONS_ID?: number;
    FID_NUM?: string;
    SIBLING?: string;
    SH_SEQUENCE?: string;
    HEALTH_NOTE?: string;
    MSRTS_NUM?: string;
    MNE?: string;
    MSD_NUMBER?: string;
    SOUND_KEY?: string;
    MIDDLE_INITIAL?: string;
    SUFFIX?: string;
    SEX?: string;
    RACE?: string;
    LATINO?: string;
    DOB?: Date;
    BIRTH_VERIFY?: string;
    MULTI_BIRTH?: string;
    BIRTH_PLACE?: string;
    LEP?: string;
    LEP_DATE?: Date;
    NEEDS_ASSESSMENT?: string;
    NEEDS_ASSESSMENT_DATE?: Date;
    TERMINATION_FLAG?: string;
    TERMINATION_DATE?: Date;
    ROUGH_KEY?: string;
    MSD_STATUS?: number;
    SECOND_LAST_NAME?: string;
    HOME_SCHOOL_INDICATOR?: string;
    BIRTH_CITY?: string;
    BIRTH_CITY_ID?: number;
    BIRTH_STATE?: string;
    BIRTH_STATE_ID?: number;
    BIRTH_COUNTRY?: string;
    CONFIDENCE?: number;
    STATUS_SOURCE?: string;
    STATUS_TARGET?: string;
    CHECK_TARGET?: Boolean;
    DUPLICATE_DEACTIVATE?: number;
    IS_MERGED?: Boolean;

    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
    SSID ?: string;
    PERSON: PERSON;

    STUDENT_SERVICES?: any;
    SCHOOL?: School;
    STUDENT_TERMINATION_STATUSES?: StudentTerminationStatus[];
    SCHOOL_ENROLLMENT_DETAILS?: SchoolEnrollmentDetailsAsl[];

    ENABLED: boolean;
    NAME: string;

    StudentLegalFirstName?: string;
    StudentLegalLastName?: string;
    Ssid? : string;
    StudentBirthDate? : string;
    StudentGenderCode? : string;
    StudentBirthCity? : string;
    Guardian1FirstName? : string;
    Guardian1LastName? : string;
    Guardian2FirstName? : string;
    Guardian2LastName? : string;
}
